import { Settings as SettingsIcon, Map, Bell, Sparkles, Bus, Cog } from "lucide-react";

export default function Settings() {
  const sections = [
    {
      title: "General",
      icon: SettingsIcon,
      items: [
        { label: "Company name", value: "Emirates Nuclear Energy Corporation (ENEC)" },
        { label: "Operating hours", value: "24/7" },
        { label: "Map center", value: "Abu Dhabi · 24.4539, 54.3773" },
      ],
    },
    {
      title: "Dispatch",
      icon: Sparkles,
      items: [
        { label: "Auto-dispatch", value: "Enabled" },
        { label: "Max pickup distance", value: "15 km" },
        { label: "Auto-cancel pending after", value: "10 min" },
        { label: "Max detour for grouping", value: "15%" },
        { label: "Route overlap threshold", value: "60%" },
      ],
    },
    {
      title: "Notifications",
      icon: Bell,
      items: [
        { label: "Driver assignment alert", value: "Push + In-app" },
        { label: "Arrival reminder", value: "Push" },
        { label: "Trip completed receipt", value: "Email + In-app" },
      ],
    },
    {
      title: "Bus Settings",
      icon: Bus,
      items: [
        { label: "Default booking cut-off", value: "30 min before departure" },
        { label: "Waitlist", value: "Enabled" },
      ],
    },
    {
      title: "Integration",
      icon: Cog,
      items: [
        { label: "Azure AD SSO", value: "Mocked (JWT)" },
        { label: "UAE Pass", value: "Mocked demo" },
        { label: "Map tiles", value: "OpenStreetMap (CARTO)" },
      ],
    },
  ];

  return (
    <div className="max-w-3xl">
      <div className="mb-5">
        <p className="text-[11px] uppercase tracking-widest text-slate-400 font-bold">Configuration</p>
        <h1 className="font-display font-bold text-3xl text-slate-900">Settings</h1>
      </div>

      <div className="space-y-4">
        {sections.map(s => (
          <div key={s.title} className="bg-white rounded-2xl border border-slate-200 overflow-hidden">
            <div className="px-5 py-4 border-b border-slate-100 flex items-center gap-2">
              <s.icon size={16} className="text-primary" />
              <p className="font-display font-bold text-slate-900">{s.title}</p>
            </div>
            <div>
              {s.items.map((it, idx) => (
                <div key={it.label} className={`flex items-center justify-between px-5 py-3 text-sm ${idx > 0 ? "border-t border-slate-100" : ""}`}>
                  <span className="text-slate-600">{it.label}</span>
                  <span className="font-semibold text-slate-900 font-mono text-xs">{it.value}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
